import {defineStore} from 'ui.vue3.pinia';

export const menuStore = defineStore('menuStore', {
    state: () => ({
        items_list: [],
        sales: [],
        additional_sale: [],
        banners: [],
        menu_utp: '',
        isMobile: false,
        parent: null,
    }),
    getters: {
        items: (state) => {
            let result = [];
            if (state.isMobile) {
                const isHasSelected = state.items_list.find(el => el.isShow === true)
                if (isHasSelected) {
                    result = state.items_list.filter(el => el.isShow === true)
                } else {
                    result = state.items_list;
                }
            } else {
                result = state.items_list;
            }
            return result;
        }
    },
    actions: {
        closeMenu() {
            this.items_list.forEach(item => item.isShow = false);
        },
    }
});